var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(e);
    r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o);
} return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) {
    var t = null != arguments[r] ? arguments[r] : {};
    r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); });
} return e; }
import { DynamicFormBuilderContainer } from "../../../../../builderPackage/components/dynamicFormBuilder/formBuilder/dynamicFormBuilder.container";
import { FormItemTypes } from "../../../../../builderPackage/components/dynamicFormBuilder/formBuilder/dynamicFormBuilder.entity";
import { ReactComponent as LeftArrow } from '../../../../../assets/images/arrow-left.svg';
import { useNavigate, useParams } from "react-router-dom";
import useMediaQuery from "@mui/material/useMediaQuery";
import { Download, MoreVert } from "@mui/icons-material";
import { Box, Divider } from "@mui/material";
import { useAppDispatch, useAppSelector } from "../../../../../store/hooks";
import { showSurface } from "../../../../../redux/awaitedSurfacesSlice";
import { ReactComponent as LinkSvg } from '../../../../../assets/images/linkIcon.svg';
import ActionMenuList from "../../../../../builderPackage/components/actionsMenuList";
import dayjs from "dayjs";
import { secondary } from "../../../../../theme/colors";
import { ShareIcon } from "../../../../../assets/images";
import { PrintIconSVG } from "../../../../spareParts/purchaseRequistion/assets/customIcons";
import ConfirmationPopUp from "../../../../fieldFailureReports/components/confirmationPopUp";
import { InfoIcon } from "../../../../../assets/customIcons";
import { areaFieldFailureReportsGetAPI, getAreaFieldFailureReportsUpdateAPICall, getCategoryPickList, getPriorityPickList } from "../../../services/apiCalls";
import { AreaFieldReportsKeys } from "../../../services/entity";
import { ChildFF } from "../../FFRs/components/ChildFFR";
import { basicDetailsAndVehicleDetails } from "../../../../fieldFailureReports/components/fieldFailureReportCreateForm/BasicDetailsAndVehicleDetails";
import { ProblemDescriptionOrChangeSequence1 } from "./ProblemDescriptionOrChangeSequence";
import { StateWiseFailuresReported } from "./StateWiseFailuresReported";
import DynamicARFsModels from "./DynamicARFModels";
import ParametersCheckedModel from "./ParametersCheckedModel";
import CustomerComplaintsModel from "./CustomerComplaintsModel";
import { ResubmitPopUp } from "./ResubmitPopUp";
import { HistoryTab } from "../../FFRs/components/HistoryTab";
import { getDefectList } from "../../../../jobCardDetails/services/apiCalls";
var AreaFieldReport = function () {
    var _crud$AreaFieldReport;
    var navigate = useNavigate();
    var dispatch = useAppDispatch();
    var id = useParams().id;
    var lgMode = useMediaQuery(function (theme) { return theme.breakpoints.up("sm"); });
    var BasicDetailsAndVehicleDetails = basicDetailsAndVehicleDetails(true);
    var crud = useAppSelector(function (state) { return state.crud; });
    var isResentByPSG = ((_crud$AreaFieldReport = crud[AreaFieldReportsKeys.get]) === null || _crud$AreaFieldReport === void 0 || (_crud$AreaFieldReport = _crud$AreaFieldReport.data) === null || _crud$AreaFieldReport === void 0 ? void 0 : _crud$AreaFieldReport.StatusKey) === 'ResentByPSG';
    var showAFRsModelDetails = function (modelData, tableModels) { return __awaiter(void 0, void 0, void 0, function () {
        var _crud$AreaFieldReport2, _crud$AreaFieldReport3, _crud$AreaFieldReport4, _crud$AreaFieldReport5;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    if (!lgMode) return [3 /*break*/, 2];
                    return [4 /*yield*/, dispatch(showSurface({
                            type: "Dialog",
                            Component: tableModels ? (modelData === null || modelData === void 0 ? void 0 : modelData.title) === "Parameters checked" ? ParametersCheckedModel : CustomerComplaintsModel : DynamicARFsModels,
                            containerProps: {
                                fullWidth: true
                            },
                            componentProps: {
                                data: tableModels ? (_crud$AreaFieldReport2 = crud[AreaFieldReportsKeys.get]) === null || _crud$AreaFieldReport2 === void 0 ? void 0 : _crud$AreaFieldReport2.data[modelData.key] : [(_crud$AreaFieldReport3 = crud[AreaFieldReportsKeys.get]) === null || _crud$AreaFieldReport3 === void 0 ? void 0 : _crud$AreaFieldReport3.data[modelData.key]],
                                title: modelData === null || modelData === void 0 ? void 0 : modelData.title
                            }
                        }))];
                case 1:
                    _a.sent();
                    return [3 /*break*/, 4];
                case 2: return [4 /*yield*/, dispatch(showSurface({
                        type: "Drawer",
                        Component: tableModels ? (modelData === null || modelData === void 0 ? void 0 : modelData.title) === "Parameters checked" ? ParametersCheckedModel : CustomerComplaintsModel : DynamicARFsModels,
                        componentProps: {
                            data: tableModels ? (_crud$AreaFieldReport4 = crud[AreaFieldReportsKeys.get]) === null || _crud$AreaFieldReport4 === void 0 ? void 0 : _crud$AreaFieldReport4.data[modelData.key] : [(_crud$AreaFieldReport5 = crud[AreaFieldReportsKeys.get]) === null || _crud$AreaFieldReport5 === void 0 ? void 0 : _crud$AreaFieldReport5.data[modelData.key]],
                            title: modelData === null || modelData === void 0 ? void 0 : modelData.title
                        },
                        containerProps: {
                            anchor: 'bottom',
                            PaperProps: {
                                sx: {
                                    width: {
                                        xs: '100%',
                                        sm: '70%',
                                        md: '40%'
                                    },
                                    height: {
                                        xs: '80%',
                                        sm: '100%'
                                    },
                                    borderTopLeftRadius: 16,
                                    borderTopRightRadius: 16
                                }
                            }
                        }
                    }))];
                case 3:
                    _a.sent();
                    _a.label = 4;
                case 4: return [2 /*return*/];
            }
        });
    }); };
    var problemDescriptionOrChangeSequence = ProblemDescriptionOrChangeSequence1(false, showAFRsModelDetails);
    var GeneralTab = __spreadArray(__spreadArray([], BasicDetailsAndVehicleDetails, true), [{
            type: FormItemTypes.CardComponent,
            name: '',
            label: "Product Details",
            columnSize: 12,
            elements: [{
                    type: FormItemTypes.CardComponent,
                    name: "",
                    label: "",
                    columnSize: 12,
                    sx: {
                        backgroundColor: 'secondary.50',
                        border: 'none'
                    },
                    elements: [{
                            type: FormItemTypes.Typography,
                            label: "Group",
                            name: "ProductGroupCode",
                            disabled: true,
                            setFieldProps: function (formValues, currValue, field) {
                                return {
                                    type: FormItemTypes.Typography,
                                    children: /*#__PURE__*/ React.createElement(Box, {
                                        sx: {
                                            display: 'flex',
                                            alignItems: 'center',
                                            gap: 1
                                        }
                                    }, (formValues === null || formValues === void 0 ? void 0 : formValues.ProductGroupName) || '-', /*#__PURE__*/ React.createElement(Divider, {
                                        orientation: "vertical",
                                        flexItem: true,
                                        sx: {
                                            borderColor: 'text.tertiary',
                                            height: '16px',
                                            alignSelf: 'center'
                                        }
                                    }), (formValues === null || formValues === void 0 ? void 0 : formValues.ProductGroupCode) || ''),
                                    labelTypographyProps: {
                                        mb: {
                                            xs: '0px',
                                            sm: '4px',
                                            md: '4px'
                                        },
                                        noWrap: true,
                                        fontWeight: 'medium',
                                        fontSize: 'sm'
                                    },
                                    containerProps: {
                                        display: 'flex',
                                        direction: {
                                            xs: 'row',
                                            sm: 'column',
                                            md: 'column'
                                        },
                                        justifyContent: {
                                            xs: 'space-between',
                                            sm: 'normal'
                                        }
                                    }
                                };
                            },
                            xs: 12,
                            sm: 3,
                            md: 3
                        }, {
                            type: FormItemTypes.Typography,
                            label: "First field report date",
                            name: "FFRReportDate",
                            valueGetter: function (formValues, field) {
                                return formValues !== null && formValues !== void 0 && formValues.FFRReportDate ? dayjs(formValues === null || formValues === void 0 ? void 0 : formValues.FFRReportDate).format('DD MMM, YYYY') : '-';
                            },
                            labelTypographyProps: {
                                mb: {
                                    xs: '0px',
                                    sm: '4px',
                                    md: '4px'
                                },
                                noWrap: true,
                                fontWeight: 'medium',
                                fontSize: 'sm'
                            },
                            containerProps: {
                                display: 'flex',
                                direction: {
                                    xs: 'row',
                                    sm: 'column',
                                    md: 'column'
                                },
                                justifyContent: {
                                    xs: 'space-between',
                                    sm: 'normal'
                                }
                            },
                            xs: 12,
                            sm: 3,
                            md: 3
                        }]
                }, {
                    type: FormItemTypes.TextInput,
                    label: 'Customer voice',
                    name: 'CustomerVoice',
                    required: true,
                    multiline: true,
                    minRows: 4,
                    xs: 12,
                    sm: 6,
                    md: 3,
                    validator: function (value, state) {
                        var leadingSpacesRegex = /^\S.*$/;
                        // Optional: block completely empty or all-space input
                        if (!leadingSpacesRegex.test(value) && (value === null || value === void 0 ? void 0 : value.length) > 0) {
                            return "Customer voice cannot be left blank";
                        }
                        if ((value === null || value === void 0 ? void 0 : value.length) < 10) {
                            return 'Customer voice must be at least 10 characters';
                        }
                        if ((value === null || value === void 0 ? void 0 : value.length) > 250) {
                            return 'Customer voice must be no longer than 250 characters';
                        }
                        return undefined;
                    }
                }, {
                    type: FormItemTypes.TextInput,
                    label: 'Defect phenomenon',
                    name: 'DefectPhenomenon',
                    required: true,
                    multiline: true,
                    minRows: 4,
                    xs: 12,
                    sm: 6,
                    md: 3,
                    validator: function (value, state) {
                        var leadingSpacesRegex = /^\S.*$/;
                        // Optional: block completely empty or all-space input
                        if (!leadingSpacesRegex.test(value) && (value === null || value === void 0 ? void 0 : value.length) > 0) {
                            return "Defect phenomenon cannot be left blank";
                        }
                        if ((value === null || value === void 0 ? void 0 : value.length) < 10) {
                            return 'Defect phenomenon must be at least 10 characters';
                        }
                        if ((value === null || value === void 0 ? void 0 : value.length) > 250) {
                            return 'Defect phenomenon must be no longer than 250 characters';
                        }
                        return undefined;
                    }
                }, {
                    type: FormItemTypes.TextInput,
                    label: 'Root cause',
                    name: 'RootCause',
                    required: true,
                    multiline: true,
                    minRows: 4,
                    xs: 12,
                    sm: 6,
                    md: 3,
                    validator: function (value, state) {
                        var leadingSpacesRegex = /^\S.*$/;
                        // Optional: block completely empty or all-space input
                        if (!leadingSpacesRegex.test(value) && (value === null || value === void 0 ? void 0 : value.length) > 0) {
                            return "Root cause cannot be left blank";
                        }
                        if ((value === null || value === void 0 ? void 0 : value.length) < 10) {
                            return 'Root cause must be at least 10 characters';
                        }
                        if ((value === null || value === void 0 ? void 0 : value.length) > 250) {
                            return 'Root cause must be no longer than 250 characters';
                        }
                        return undefined;
                    }
                }]
        }, {
            type: FormItemTypes.CardComponent,
            name: '',
            label: "Defective part details",
            columnSize: 12,
            elements: [{
                    type: FormItemTypes.CardComponent,
                    name: "",
                    label: "",
                    xs: 12,
                    sm: 3,
                    md: 3,
                    sx: {
                        backgroundColor: 'secondary.50',
                        border: 'none'
                    },
                    elements: [{
                            type: FormItemTypes.Typography,
                            label: "Main defective part",
                            name: "PartName",
                            disabled: true,
                            setFieldProps: function (formValues, currValue, field) {
                                return {
                                    type: FormItemTypes.Typography,
                                    children: /*#__PURE__*/ React.createElement(Box, {
                                        sx: {
                                            display: 'flex',
                                            alignItems: 'center',
                                            gap: 1
                                        }
                                    }, (formValues === null || formValues === void 0 ? void 0 : formValues.PartName) || '-', /*#__PURE__*/ React.createElement(Divider, {
                                        orientation: "vertical",
                                        flexItem: true,
                                        sx: {
                                            borderColor: 'text.tertiary',
                                            height: '16px',
                                            alignSelf: 'center'
                                        }
                                    }), (formValues === null || formValues === void 0 ? void 0 : formValues.PartCode) || ''),
                                    labelTypographyProps: {
                                        mb: {
                                            xs: '0px',
                                            sm: '4px',
                                            md: '4px'
                                        },
                                        noWrap: true,
                                        fontWeight: 'medium',
                                        fontSize: 'sm'
                                    },
                                    containerProps: {
                                        display: 'flex',
                                        direction: {
                                            xs: 'row',
                                            sm: 'column',
                                            md: 'column'
                                        },
                                        justifyContent: {
                                            xs: 'space-between',
                                            sm: 'normal'
                                        }
                                    }
                                };
                            },
                            columnSize: 12
                        }]
                }, {
                    type: FormItemTypes.ContainerItem,
                    name: '',
                    columnSize: 12,
                    elements: [{
                            type: FormItemTypes.SearchSelect,
                            label: "Priority",
                            name: "PriorityId",
                            value: null,
                            required: true,
                            getListData: getPriorityPickList,
                            displayExpr: "Name",
                            valueExpr: "id",
                            getOptionLabel: function (option) { return option ? "".concat(option.Name, " - ").concat(option.Code) : ""; }
                        }, {
                            type: FormItemTypes.SearchSelect,
                            label: "Category",
                            name: "CategoryId",
                            value: null,
                            required: true,
                            getListData: getCategoryPickList,
                            displayExpr: "Name",
                            valueExpr: "id",
                            getOptionLabel: function (option) { return option ? "".concat(option.Name, " - ").concat(option.Code) : ""; }
                        }, {
                            type: FormItemTypes.SearchSelect,
                            label: "Defect",
                            name: "DefectCodeId",
                            value: null,
                            required: true,
                            displayExpr: "Name",
                            valueExpr: "id",
                            apiRequest: {
                                Name: "Part Defect Code"
                            },
                            getListData: getDefectList,
                            getOptionLabel: function (option) { return option ? "".concat(option.ComplaintName, " - ").concat(option.ComplaintCode) : ""; }
                        }]
                }]
        }, {
            type: FormItemTypes.Custom,
            name: 'StatewiseCount',
            columnSize: 12,
            element: StateWiseFailuresReported
        }], false);
    var formState = [{
            type: FormItemTypes.ContainerItem,
            name: "PageHeader",
            columnSize: 12,
            justifyContent: 'space-between',
            spacing: 0,
            p: 1,
            elements: [{
                    type: FormItemTypes.ContainerItem,
                    name: '',
                    xs: 12,
                    sm: 5,
                    md: true,
                    lg: true,
                    spacing: 0,
                    elements: [{
                            type: FormItemTypes.IconButton,
                            name: "",
                            children: /*#__PURE__*/ React.createElement(LeftArrow, null),
                            sx: {
                                color: 'secondary.600'
                            },
                            columnSize: 0,
                            onClick: function () {
                                navigate('/areaFieldReports/afr');
                            }
                        }, {
                            type: FormItemTypes.Typography,
                            name: "AFRDocumentName",
                            label: "",
                            columnSize: 0,
                            fontSize: "xxl",
                            fontWeight: "strong"
                        }, {
                            type: FormItemTypes.Chip,
                            name: "Status",
                            value: null,
                            columnSize: true,
                            color: "primary",
                            sx: {
                                marginTop: '3px',
                                marginLeft: '5px'
                            }
                        }, !lgMode ? {
                            type: FormItemTypes.Button,
                            name: 'More',
                            children: /*#__PURE__*/ React.createElement(MoreVert, null),
                            size: 'small',
                            variant: 'text',
                            color: 'secondary',
                            sx: {
                                p: '7px'
                            },
                            columnSize: 0,
                            setFormState: function (state, e) { return __awaiter(void 0, void 0, void 0, function () {
                                var action;
                                return __generator(this, function (_a) {
                                    switch (_a.label) {
                                        case 0: return [4 /*yield*/, dispatch(showSurface({
                                                type: 'Menu',
                                                containerProps: {
                                                    anchorEl: e.target.parentElement
                                                },
                                                Component: ActionMenuList,
                                                componentProps: {
                                                    items: [{
                                                            id: 'download',
                                                            children: "Download"
                                                        }, {
                                                            id: 'share',
                                                            children: "Share"
                                                        }, {
                                                            id: 'print',
                                                            children: "Print"
                                                        }, {
                                                            id: 'quick links',
                                                            children: 'Quick links'
                                                        }]
                                                }
                                            }))];
                                        case 1:
                                            action = _a.sent();
                                            return [2 /*return*/];
                                    }
                                });
                            }); }
                        } : null]
                }, {
                    type: FormItemTypes.ContainerItem,
                    name: '',
                    xs: 12,
                    sm: true,
                    md: true,
                    lg: true,
                    spacing: 0,
                    item: false,
                    gap: 1,
                    justifyContent: {
                        xs: "space-between",
                        sm: 'end'
                    },
                    alignContent: 'center',
                    elements: lgMode ? [{
                            type: FormItemTypes.Typography,
                            name: "AFRDocumentName",
                            label: "DOC NO :",
                            value: '-',
                            containerProps: {
                                justifyContent: {
                                    xs: "space-between",
                                    sm: 'end'
                                },
                                display: "inline-flex",
                                alignItems: "baseline",
                                gap: 1
                            },
                            labelTypographyProps: {
                                mb: 0,
                                noWrap: true
                            },
                            xs: 12,
                            sm: true,
                            md: true,
                            lg: true
                        }, {
                            type: FormItemTypes.Typography,
                            name: "DocumentDate",
                            label: "DOC DATE:",
                            containerProps: {
                                display: "inline-flex",
                                justifyContent: {
                                    xs: "space-between",
                                    sm: 'end'
                                },
                                alignItems: "baseline",
                                gap: 1
                            },
                            labelTypographyProps: {
                                mb: 0,
                                noWrap: true
                            },
                            columnSize: 0,
                            valueGetter: function (formValues, field) {
                                var _field$name;
                                var value = formValues === null || formValues === void 0 ? void 0 : formValues[(_field$name = field === null || field === void 0 ? void 0 : field.name) !== null && _field$name !== void 0 ? _field$name : ""];
                                if (value) {
                                    return dayjs(value).format("DD MMM, YYYY");
                                }
                                return dayjs().format("DD MMM, YYYY");
                            }
                        }] : [{
                            type: FormItemTypes.Typography,
                            name: "AFRDocumentName",
                            label: "DOC NO :",
                            value: '-',
                            containerProps: {
                                justifyContent: {
                                    xs: "space-between",
                                    sm: 'end'
                                },
                                display: "inline-flex",
                                alignItems: "baseline",
                                gap: 1,
                                mx: 1
                            },
                            labelTypographyProps: {
                                mb: 0,
                                mx: 1,
                                noWrap: true
                            },
                            xs: 12
                        }, {
                            type: FormItemTypes.Typography,
                            name: "DocumentDate",
                            label: "DOC DATE:",
                            value: '-',
                            containerProps: {
                                display: "inline-flex",
                                mx: 1,
                                justifyContent: {
                                    xs: "space-between",
                                    sm: 'end'
                                },
                                alignItems: "baseline",
                                gap: 1
                            },
                            labelTypographyProps: {
                                mb: 0,
                                mx: 1,
                                noWrap: true
                            },
                            xs: 12,
                            valueGetter: function (formValues, field) {
                                var _field$name2, _field$name3;
                                return formValues !== null && formValues !== void 0 && formValues[(_field$name2 = field === null || field === void 0 ? void 0 : field.name) !== null && _field$name2 !== void 0 ? _field$name2 : ""] ? dayjs(formValues === null || formValues === void 0 ? void 0 : formValues[(_field$name3 = field === null || field === void 0 ? void 0 : field.name) !== null && _field$name3 !== void 0 ? _field$name3 : ""]).format("DD MMM, YYYY") : "-";
                            }
                        }]
                }]
        }, lgMode ? {
            type: FormItemTypes.Box,
            name: "",
            height: "68px",
            padding: "16px 24px",
            gap: "12px",
            bgcolor: secondary[100],
            mt: 2,
            borderTop: "1px solid ",
            borderBottom: "1px solid ",
            borderColor: secondary[200],
            columnSize: 12,
            justifyContent: "space-between",
            display: "flex",
            elements: [{
                    type: FormItemTypes.Box,
                    name: "",
                    columnSize: 3
                }, {
                    type: FormItemTypes.Box,
                    name: "",
                    justifyContent: "end",
                    display: "flex",
                    columnSize: 9,
                    gap: "12px",
                    elements: [{
                            type: FormItemTypes.Button,
                            name: "",
                            variant: "text",
                            children: "Quick links",
                            columnSize: 0,
                            sx: {
                                bgcolor: "transparent",
                                fontWeight: "medium"
                            },
                            startIcon: /*#__PURE__*/ React.createElement(LinkSvg, null)
                        }, {
                            type: FormItemTypes.Button,
                            name: "",
                            children: /*#__PURE__*/ React.createElement(Download, null),
                            columnSize: 0,
                            variant: "outlined",
                            disabled: true,
                            sx: {
                                padding: "8px"
                            }
                        }, {
                            type: FormItemTypes.Button,
                            name: "",
                            children: /*#__PURE__*/ React.createElement("img", {
                                src: ShareIcon,
                                alt: "shareicon",
                                loading: "lazy"
                            }),
                            columnSize: 0,
                            variant: "outlined",
                            disabled: true,
                            sx: {
                                padding: "8px"
                            }
                        }, {
                            type: FormItemTypes.Button,
                            name: "",
                            children: /*#__PURE__*/ React.createElement(PrintIconSVG, null),
                            columnSize: 0,
                            variant: "outlined",
                            disabled: true,
                            sx: {
                                padding: "8px"
                            }
                        }, {
                            type: FormItemTypes.Box,
                            name: "",
                            columnSize: 0,
                            height: "100%",
                            width: "1px",
                            bgcolor: "rgba(0,0,0,0.1)",
                            mx: 1
                        }, isResentByPSG ? {
                            type: FormItemTypes.Button,
                            name: '',
                            children: 'Close AFR',
                            variant: "outlined",
                            columnSize: 0
                        } : null, isResentByPSG ? {
                            type: FormItemTypes.Button,
                            name: "submit",
                            label: "",
                            children: "Resubmit",
                            columnSize: 0,
                            variant: "contained",
                            color: "primary",
                            setFormState: function (formValues, currValue) { return __awaiter(void 0, void 0, void 0, function () {
                                var ResubmitPopUpData;
                                return __generator(this, function (_a) {
                                    switch (_a.label) {
                                        case 0: return [4 /*yield*/, dispatch(showSurface({
                                                type: 'Dialog',
                                                Component: ResubmitPopUp,
                                                componentProps: {
                                                    request: formValues
                                                },
                                                containerProps: {
                                                    fullWidth: true,
                                                    PaperProps: {
                                                        sx: {
                                                            borderRadius: '12px'
                                                        }
                                                    }
                                                }
                                            }))];
                                        case 1:
                                            ResubmitPopUpData = _a.sent();
                                            if (ResubmitPopUpData.payload) {
                                                return [2 /*return*/, _objectSpread(_objectSpread({}, ResubmitPopUpData.payload), {}, {
                                                        isSubmit: true
                                                    })];
                                            }
                                            else {
                                                return [2 /*return*/, {
                                                        isSubmit: false
                                                    }];
                                            }
                                            return [2 /*return*/];
                                    }
                                });
                            }); },
                            onClick: function (e, formValues) {
                                return __awaiter(this, void 0, void 0, function () {
                                    return __generator(this, function (_a) {
                                        return [2 /*return*/, 'submit'];
                                    });
                                });
                            }
                        } : null, !isResentByPSG ? {
                            type: FormItemTypes.Button,
                            name: "submit",
                            label: "",
                            children: "Submit",
                            columnSize: 0,
                            variant: "contained",
                            color: "primary",
                            setFormState: function () { return __awaiter(void 0, void 0, void 0, function () {
                                return __generator(this, function (_a) {
                                    return [2 /*return*/, {
                                            IsSubmit: 1
                                        }];
                                });
                            }); },
                            onClick: function () {
                                return __awaiter(this, void 0, void 0, function () {
                                    var result;
                                    return __generator(this, function (_a) {
                                        switch (_a.label) {
                                            case 0: return [4 /*yield*/, dispatch(showSurface({
                                                    type: 'Dialog',
                                                    Component: ConfirmationPopUp,
                                                    containerProps: {
                                                        fullWidth: true,
                                                        PaperProps: {
                                                            sx: {
                                                                borderRadius: '12px',
                                                                width: {
                                                                    sm: '350px',
                                                                    md: '450px',
                                                                    lg: '450px'
                                                                }
                                                            }
                                                        }
                                                    },
                                                    //Passing dynamic props
                                                    componentProps: {
                                                        unsavedChangesMessage: 'Are sure you want to submit?',
                                                        changesLostMessage: 'Document cannot be edited after submission.',
                                                        confirmButtonLabel: 'Submit',
                                                        discardButtonLabel: 'Cancel',
                                                        icon: /*#__PURE__*/ React.createElement(InfoIcon, null),
                                                        bgColor: 'warning.100',
                                                        hoverbgColor: 'warning.100'
                                                        // onClose: (isConfirmed: boolean) => {
                                                        //   console.log(isConfirmed ? 'Confirmed' : 'Canceled');
                                                        // },
                                                    }
                                                }))];
                                            case 1:
                                                result = _a.sent();
                                                if (result.payload) {
                                                    return [2 /*return*/, 'submit'];
                                                }
                                                return [2 /*return*/];
                                        }
                                    });
                                });
                            }
                        } : null]
                }]
        } : null, {
            type: FormItemTypes.ContainerItem,
            name: "",
            columnSize: 12,
            spacing: 0,
            containerProps: {
                spacing: 0
            },
            elements: [{
                    type: FormItemTypes.Tabs,
                    name: "Tabs",
                    tabs: __spreadArray(__spreadArray([{
                            id: "0",
                            label: "General",
                            elements: GeneralTab,
                            containerProps: {
                                px: 3
                            }
                        }, {
                            id: "1",
                            label: "Problem description OR Change sequence",
                            containerProps: {
                                px: 3
                            },
                            elements: problemDescriptionOrChangeSequence
                        }], (isResentByPSG ? [{
                            id: "4",
                            label: "History",
                            elements: [{
                                    type: FormItemTypes.Custom,
                                    name: "history",
                                    columnSize: 12,
                                    spacing: 0,
                                    element: HistoryTab
                                }]
                        }] : []), true), [{
                            id: "5",
                            label: "Child FFR",
                            containerProps: {
                                px: lgMode ? 3 : 0
                            },
                            elements: [{
                                    type: FormItemTypes.Custom,
                                    name: "",
                                    columnSize: 12,
                                    element: ChildFF
                                }]
                        }], false),
                    valueExpr: "id",
                    displayExpr: "label",
                    columnSize: 12,
                    variant: "scrollable",
                    sx: {
                        margin: "0px 24px"
                    }
                }]
        }, !lgMode ? {
            type: FormItemTypes.ContainerItem,
            name: 'Footer',
            columnSize: 12,
            justifyContent: 'end',
            spacing: 0,
            gap: 1,
            sx: {
                position: 'fixed',
                bottom: 0,
                left: 0,
                right: 0,
                padding: 2,
                backgroundColor: 'background.paper',
                borderTop: '1px solid',
                borderColor: 'divider',
                zIndex: 1
            },
            elements: [isResentByPSG ? {
                    type: FormItemTypes.Button,
                    name: '',
                    children: 'Close AFR',
                    variant: "outlined",
                    columnSize: 0
                } : null, isResentByPSG ? {
                    type: FormItemTypes.Button,
                    name: "submit",
                    label: "",
                    children: "Resubmit",
                    columnSize: 0,
                    variant: "contained",
                    color: "primary",
                    setFormState: function (formValues, currValue) { return __awaiter(void 0, void 0, void 0, function () {
                        var ResubmitPopUpData;
                        return __generator(this, function (_a) {
                            switch (_a.label) {
                                case 0: return [4 /*yield*/, dispatch(showSurface({
                                        type: 'Drawer',
                                        Component: ResubmitPopUp,
                                        componentProps: {
                                            request: formValues
                                        },
                                        containerProps: {
                                            anchor: 'bottom',
                                            PaperProps: {
                                                sx: {
                                                    width: {
                                                        xs: '100%',
                                                        sm: '70%',
                                                        md: '40%'
                                                    },
                                                    height: {
                                                        xs: '80%',
                                                        sm: '100%'
                                                    },
                                                    borderTopLeftRadius: 16,
                                                    borderTopRightRadius: 16
                                                }
                                            }
                                        }
                                    }))];
                                case 1:
                                    ResubmitPopUpData = _a.sent();
                                    if (ResubmitPopUpData.payload) {
                                        return [2 /*return*/, _objectSpread(_objectSpread({}, ResubmitPopUpData.payload), {}, {
                                                isSubmit: true
                                            })];
                                    }
                                    else {
                                        return [2 /*return*/, {
                                                isSubmit: false
                                            }];
                                    }
                                    return [2 /*return*/];
                            }
                        });
                    }); },
                    onClick: function (e, formValues) {
                        return __awaiter(this, void 0, void 0, function () {
                            return __generator(this, function (_a) {
                                return [2 /*return*/, 'submit'];
                            });
                        });
                    }
                } : null, !isResentByPSG ? {
                    type: FormItemTypes.Button,
                    name: "submit",
                    label: "",
                    children: "Submit",
                    columnSize: 0,
                    variant: "contained",
                    color: "primary",
                    setFormState: function () { return __awaiter(void 0, void 0, void 0, function () {
                        return __generator(this, function (_a) {
                            return [2 /*return*/, {
                                    IsSubmit: 1
                                }];
                        });
                    }); },
                    onClick: function () {
                        return __awaiter(this, void 0, void 0, function () {
                            var result;
                            return __generator(this, function (_a) {
                                switch (_a.label) {
                                    case 0: return [4 /*yield*/, dispatch(showSurface({
                                            type: 'Dialog',
                                            Component: ConfirmationPopUp,
                                            containerProps: {
                                                fullWidth: true,
                                                PaperProps: {
                                                    sx: {
                                                        borderRadius: '12px',
                                                        width: {
                                                            sm: '350px',
                                                            md: '450px',
                                                            lg: '450px'
                                                        }
                                                    }
                                                }
                                            },
                                            //Passing dynamic props
                                            componentProps: {
                                                unsavedChangesMessage: 'Are sure you want to submit?',
                                                changesLostMessage: 'Document cannot be edited after submission.',
                                                confirmButtonLabel: 'Submit',
                                                discardButtonLabel: 'Cancel',
                                                icon: /*#__PURE__*/ React.createElement(InfoIcon, null),
                                                bgColor: 'warning.100',
                                                hoverbgColor: 'warning.100'
                                                // onClose: (isConfirmed: boolean) => {
                                                //   console.log(isConfirmed ? 'Confirmed' : 'Canceled');
                                                // },
                                            }
                                        }))];
                                    case 1:
                                        result = _a.sent();
                                        if (result.payload) {
                                            return [2 /*return*/, 'submit'];
                                        }
                                        return [2 /*return*/];
                                }
                            });
                        });
                    }
                } : null]
        } : null];
    return /*#__PURE__*/ React.createElement(React.Fragment, null, /*#__PURE__*/ React.createElement(DynamicFormBuilderContainer, {
        formData: formState,
        getFormAPI: areaFieldFailureReportsGetAPI,
        getKey: AreaFieldReportsKeys.get,
        getRequest: {
            id: id
        },
        gridProps: {
            spacing: 0
        },
        mode: "edit",
        updateFormAPI: getAreaFieldFailureReportsUpdateAPICall,
        updateKey: AreaFieldReportsKeys.update,
        updateRequest: {
            id: id
        }
    }));
};
export default AreaFieldReport;
